import React from 'react';
import '../../assets/css/App.css';
import Header from "../../features/Layout/Header";
import Footer from "../../features/Layout/Footer";
import { withTranslation } from 'react-i18next';


class Terms extends React.Component {
    componentDidMount() {
        const { t } = this.props;
        if (window.location.pathname.indexOf('romotion/2929')>0) {
            setTimeout(function(){window.location.href="/deal/6735d5e391444a1ea980e89781392d97"} , 100);
            document.getElementById("h3").innerHTML = t('promotions.generic.legacyBucharestDeal');
        }

    }

    render() {
        const { t } = this.props;

        return(

            <div className="App Contact">
                <Header hide="true" hideSearch={true} />
                <main>
                   <h1>{t('promotions.generic.dealTitle', { id: this.props.match.params.id })}</h1>
                   <p>{t('promotions.generic.dealDescription')}</p>
                   <h3 id="h3">{t('promotions.generic.dealWillBePublished')}</h3>
                   <p>{t('promotions.generic.disclaimer')}</p>

                   <img src="/images/secret-2681508_640.jpg" alt={t('promotions.generic.secretDeal')}></img>

                </main>
                <Footer />
            </div>
        );
    }
}

export default withTranslation()(Terms);